import { FirearmStorageLocationSearchComponentBase } from './firearm-storage-location-search.component.base';
import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitService, FirearmStorageLocationService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-firearm-storage-location-search',
  templateUrl: './firearm-storage-location-search.component.html',
  styleUrls: ['./firearm-storage-location-search.component.scss']
})
export class FirearmStorageLocationSearchComponent extends FirearmStorageLocationSearchComponentBase {

  displayedColumns: string[] = [ 'firearmStorageLocationId', 'businessUnit.buId', 'location', 'description','locationType','addr1', 'addr2', 'addr3', 'town', 'county', 'postcode', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'actions', 'disposalLocation'];
  disabledColumns: string[] = [ 'firearmStorageLocationId', 'addr1', 'addr2', 'addr3', 'county', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate'];

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected firearmStorageLocationService: FirearmStorageLocationService,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, firearmStorageLocationService, businessUnitService, refCodeStorage, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    this.businessUnitLoadSelectionList();
    this.locationTypeLoadSelectionList();
    
    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
    // The base hook starts the initial search. Restore filters first so returning
    // from an item uses the same values displayed in the filter controls.
    super.onInitAsyncComplete();
  }
  
  resetSearchForm() {
    // placeholder
  }
  
  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }
  
}



